module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Incoming-box-c0685e9e140b1b510b2c465bd13e4349.svg";